import { useState } from "react";
import { toast } from "sonner";
import { UserPlus, KeyRound, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Panel, Empty } from "@/components/common";

export default function ClientUsers({ clientId, users, onChange }) {
  const [f, setF] = useState({ email: "", password: "", name: "" });
  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/admin/clients/${clientId}/users`, f);
      toast.success("Utente aggiunto");
      setF({ email: "", password: "", name: "" });
      onChange();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const update = async (u, body, msg) => {
    try {
      await api.put(`/admin/users/${u.id}`, body);
      toast.success(msg);
      onChange();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const resetPw = (u) => {
    const pw = window.prompt(`Nuova password per ${u.email} (min. 8 caratteri)`);
    if (pw) update(u, { password: pw }, "Password aggiornata");
  };
  const remove = async (u) => {
    if (!window.confirm(`Eliminare l'utente ${u.email}?`)) return;
    await api.delete(`/admin/users/${u.id}`);
    toast.success("Utente eliminato");
    onChange();
  };
  return (
    <div className="space-y-6">
      <Panel title="Aggiungi email di accesso">
        <form onSubmit={add} className="p-5 grid sm:grid-cols-[1fr_1fr_1fr_auto] gap-3">
          <Input type="email" required placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="new-user-email-input" />
          <Input type="text" required minLength={8} placeholder="Password (min. 8)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="new-user-password-input" />
          <Input placeholder="Nome" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="new-user-name-input" />
          <Button type="submit" className="bg-blue-600 hover:bg-blue-500" data-testid="add-user-button"><UserPlus size={15} className="mr-1.5" />Aggiungi</Button>
        </form>
      </Panel>
      <Panel title="Utenti abilitati">
        {users.length ? (
          <ul className="divide-y divide-slate-800">
            {users.map((u) => (
              <li key={u.id} className="flex items-center gap-4 px-5 py-3.5" data-testid={`user-row-${u.id}`}>
                <div className="min-w-0 flex-1">
                  <div className="font-mono text-sm truncate">{u.email}</div>
                  <div className="text-xs text-slate-500">{u.name || "—"} · ultimo accesso {fmtDate(u.last_login)}</div>
                </div>
                <label className="flex items-center gap-2 text-xs text-slate-400">
                  <Switch checked={u.active} onCheckedChange={(v) => update(u, { active: v }, v ? "Utente abilitato" : "Utente disabilitato")} data-testid={`user-active-switch-${u.id}`} />Attivo
                </label>
                <Button size="sm" variant="outline" className="border-slate-700 bg-transparent" onClick={() => resetPw(u)} data-testid={`reset-password-${u.id}`}><KeyRound size={14} className="mr-1.5" />Password</Button>
                <Button size="icon" variant="ghost" className="text-rose-400" onClick={() => remove(u)} data-testid={`delete-user-${u.id}`}><Trash2 size={15} /></Button>
              </li>
            ))}
          </ul>
        ) : <Empty text="Nessun utente: aggiungi almeno un'email per consentire l'accesso." />}
      </Panel>
    </div>
  );
}
